import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { scrollToCheckout } from '../lib/data';
interface CTAButtonProps {
  label: string;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
}
export function CTAButton({
  label,
  className = '',
  onClick,
  fullWidth = true
}: CTAButtonProps) {
  return <button type="button" onClick={onClick ?? scrollToCheckout} className={`group relative inline-flex items-center justify-center gap-2 rounded-full bg-hockey-pink px-7 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-hockey-pink/30 transition-all active:scale-[0.97] hover:bg-hockey-pinkdark ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-127" data-mp="2fysb4yws4ppt">
      <span className="pointer-events-none absolute inset-0 rounded-full ring-2 ring-hockey-pink/40 animate-ping opacity-40" data-id="element-128" data-mp="2yql2kow7a2vf" />
      <span className="relative" data-id="element-129" data-mp="3cnhrulwo7ca7">{label}</span>
      <ArrowRightIcon className="relative h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-130" data-mp="38pabhs64cczj" />
    </button>;
}